import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import {
  EnumListFilter,
  NumberFilter,
  StringFilter,
} from 'src/app/filter/filter';
import { AtomService } from '../atom.service';
import { Firm } from './firm.resource';
import { Shortcode } from './shortcode.ressource';
import {
  Keywordrulesdvp4m,
  Keywordrulesdvp4mConfig,
} from './keywordrulesdvp4m.ressource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import {
  FirmConfig,
  ShortcodeConfig,
} from 'src/app/shared/tools/search/search-config';

@Resource({
  type: 'keywords',
})
export class Keyword extends AtomResource {
  @Attribute() keyword?: string;
  @Attribute() priority?: number;

  @Relationship() shortcode?: Shortcode;
  @Relationship() ownerfirm?: Firm;
  @Relationship() keywordrulesdvp4m?: Keywordrulesdvp4m;
}
export class KeywordsConfig implements ResourceConfig {
  hosted = 'shortcode';
  tables = {
    options: {
      copy: true,
    },
    includes: [
      'shortcode',
      'ownerfirm.headquarterscountry',
      'shortcode.enduserproviderjob.firm.headquarterscountry',
      'keywordrulesdvp4m.pack',
    ],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main', translatable: false }],
        header: 'ID',
        translatable: false,
        displayed: true,
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'shortcode',
        displayedDatas: [
          {
            path: ['shortcode.shortcode'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Shortcode',
        displayed: true,
        link: {
          resource: 'shortcodes',
          filter: 'shortcode.id',
          icon: 'dialpad',
        },
        sort: 'shortcode.shortcode',
      },
      {
        columnDef: 'keyword',
        displayedDatas: [
          { path: ['keyword'], class: 'main', translatable: false },
        ],
        header: 'Keyword',
        translatable: false,
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'keyword',
      },
      {
        columnDef: 'shortcode.enduserproviderjob.firm',
        displayedDatas: [
          {
            path: ['shortcode.enduserproviderjob.firm.name'],
            class: 'mat-body-2',
            translatable: true,
          },
          {
            path: ['shortcode.enduserproviderjob.firm.headquarterscountry.id'],
            class: 'mat-body-1',
            translatable: false,
          },
        ],
        header: 'Enduser Provider',
        displayed: true,
        link: {
          resource: 'firms',
          filter: 'shortcode.enduserproviderjob.firm.id',
          icon: 'business',
        },
        options: {
          flag: 'shortcode.enduserproviderjob.firm.headquarterscountry.id',
        },
        sort: 'shortcode.enduserproviderjob.firm.name',
      },
      {
        columnDef: 'keywordrulesdvp4m.action',
        displayedDatas: [
          {
            path: ['keywordrulesdvp4m.action'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Action',
        displayed: true,
        sort: 'keywordrulesdvp4m.action',
      },
      {
        columnDef: 'keywordrulesdvp4m.mode',
        displayedDatas: [
          {
            path: ['keywordrulesdvp4m.mode'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Mode',
        displayed: true,
        sort: 'keywordrulesdvp4m.mode',
      },
      {
        columnDef: 'priority',
        displayedDatas: [
          { path: ['priority'], class: 'main', translatable: false },
        ],
        header: 'Priority',
        translatable: false,
        displayed: false,
      },
      {
        columnDef: 'ownerfirm',
        displayedDatas: [
          {
            path: ['ownerfirm.name'],
            class: 'mat-body-2',
            translatable: true,
          },
          {
            path: ['ownerfirm.headquarterscountry.id'],
            class: 'mat-body-1',
            translatable: false,
          },
        ],
        header: 'Owner Firm',
        displayed: false,
        link: {
          resource: 'firms',
          filter: 'firm.id',
          icon: 'business',
        },
        sort: 'ownerfirm.name',
      },
      {
        columnDef: 'pack.id',
        displayedDatas: [
          {
            path: ['keywordrulesdvp4m.pack.id'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Pack ID',
        displayed: false,
        link: {
          resource: 'packs',
          filter: 'keywordrulesdvp4m.pack.id',
          icon: 'inventory',
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'abc',
      title: [
        {
          path: ['keyword'],
          translatable: false,
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        columns: true,
        list: [
          {
            icon: 'dialpad',
            title: 'Shortcode',
            APIKey: 'shortcode',
            value: {
              path: ['shortcode.shortcode'],
              translatable: false,
            },
            link: {
              resource: 'shortcodes',
              filter: 'shortcode.id',
            },
          },
          {
            icon: 'language',
            title: 'Owner firm',
            APIKey: 'ownerfirm',
            value: {
              path: ['ownerfirm.name'],
              translatable: true,
            },
            link: {
              resource: 'firms',
              filter: 'ownerfirm.id',
            },
          },
          {
            icon: 'low_priority',
            title: 'Priority',
            APIKey: 'priority',
            value: {
              path: ['priority'],
              translatable: false,
            },
          },
        ],
      },
      {
        resource: {
          APIKey: 'keywordrulesdvp4m',
          config: new Keywordrulesdvp4mConfig(this.atom),
        },
      },
    ],
  };
  wizard = {
    noCloseAfterCreation: true,
    tabs: [
      {
        title: 'Keyword',
        formGroup: 'keyword',
        list: [
          {
            type: 'text',
            formControl: 'keyword',
            title: 'Keyword',
            APIKey: 'keyword',
            required: true,
            check: 'like',
            uppercase: true,
          },
          {
            type: 'resource',
            title: 'Shortcode',
            formControl: 'shortcode',
            search: new ShortcodeConfig(),
            APIKey: 'shortcode',
            required: true,
            check: 'equal',
          },
          {
            type: 'number',
            formControl: 'priority',
            title: 'Priority',
            APIKey: 'priority',
            required: true,
            noCols: true,
            presetValue: 0,
          },
          {
            type: 'resource',
            title: 'Owner Firm',
            formControl: 'ownerfirm',
            search: new FirmConfig(this.atom),
            required: true,
            noCols: true,
            hint: 'Digital Virgo by default',
          },
        ],
      },
      {
        title: 'Keyword Rules DVP4M',
        formGroup: 'keywordrulesdvp4m',
        list: [
          {
            type: 'ownResource',
            formControl: 'ordersequencerules',
            resource: {
              APIKey: 'keywordrulesdvp4m',
              config: new Keywordrulesdvp4mConfig(this.atom),
              multiple: false,
            },
          },
        ],
      },
    ],
  };
  resource = Keyword;
  resourceName = 'Keywords';
  resourceKey = 'keywords';
  resourceKeySingle = 'keyword';
  includes = [
    'shortcode.country',
    'shortcode.enduserproviderjob.firm.headquarterscountry',
    'shortcode.enduserproviderjob.activity',
    'ownerfirm.headquarterscountry',
    'keywordrulesdvp4m.lang',
    'keywordrulesdvp4m.kinematic',
    'keywordrulesdvp4m.orderchannel',
    'keywordrulesdvp4m.pack',
    'keywordrulesdvp4m.legalfirm',
    'keywordrulesdvp4m.products',
    'keywordrulesdvp4m.offers',
    'keywordrulesdvp4m.keyword.shortcode.country',
    'keywordrulesdvp4m.keyword.shortcode.enduserproviderjob',
  ];
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('keyword', 'Keyword'),
    new StringFilter('shortcode.country.id', 'Country ID', true),
    new StringFilter('shortcode.country.name', 'Country Name'),
    new NumberFilter('shortcode.id', 'Shortcode ID'),
    new StringFilter('shortcode.shortcode', 'Shortcode'),
    new StringFilter('ownerfirm.name', 'Ownerfirm Name'),
    new NumberFilter('ownerfirm.id', 'Ownerfirm ID'),
    new NumberFilter('keywordrulesdvp4m.pack.id', 'Pack ID'),
    new NumberFilter('keywordrulesdvp4m.products.id', 'Product ID'),
    new NumberFilter('keywordrulesdvp4m.offers.id', 'Offer ID'),
    new EnumListFilter(
      this.atom,
      'keywordrulesdvp4m',
      'action',
      'keywordrulesdvp4m.action',
      'Action'
    ),
    new StringFilter(
      'shortcode.enduserproviderjob.firm.name',
      'Enduser Provider'
    ),
  ];
  constructor(private atom: AtomService) {}
}
